import React from 'react'
import { GridItem } from '../../shared/grid-item'
import { ListedItemPlaceholder } from '../listed-item/listed-item-placeholder'

export const PlaceholderArrayComponent: React.FC = () => {
  const placeholderArray = []
  //eslint-disable-next-line
  for (let i = 0; i < 12; i++) {
    placeholderArray.push(
      <GridItem key={i} xxxs={12} xxs={6} xs={4} md={4} lg={3} xl={2}>
        <ListedItemPlaceholder />
      </GridItem>
    )
  }
  return <>{placeholderArray}</>
}
